import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import getLocalData from "../../lib/getLocalData";
import getNestedObject from "../../lib/getNestedObject";
import getHeaderData from "../../lib/getHeaderData";
import getAppErrors from "../../lib/appErrors";
import getRegularPlaceData from "../../lib/getRegularPlaceData";
import Api from "../../lib/componentApi";
import setLocalDeliveryData from "../../lib/setLocalDeliveryData";

import LocationSearchInput from "../Common/Places";
import AppErrors from "../Common/AppErrors";
import customUrlSearchParams from "../../lib/customUrlSearchParams";
import mixPanel from "../../lib/mixPanel";

class DeliverTo extends Component {
  constructor(props) {
    super(props);
    const staticContext = props.staticContext;
    const searchParams = new customUrlSearchParams(props.location.search);
    let addresses = [];
    const { initialData } = getHeaderData(staticContext, "user");
    if (initialData) {
      addresses = initialData.addresses;
    }
    let deliveryDetails;
    //eslint-disable-next-line
    if (__isBrowser__) {
      deliveryDetails = getLocalData("deliveryDetails") || {};
    } else {
      deliveryDetails =
        (staticContext &&
          staticContext.serverData &&
          JSON.parse(staticContext.serverData)) ||
        {};
    }
    const routeName = getNestedObject(deliveryDetails, ["routeName"], "");
    const postalCode =
      searchParams.get("postcode") ||
      getNestedObject(deliveryDetails, ["postalCode"], "");
    const title = getNestedObject(deliveryDetails, ["title"], "");
    const flatNumber = getNestedObject(deliveryDetails, ["flatNumber"], "");
    const preOrder =
      searchParams.get("time") ||
      getNestedObject(deliveryDetails, ["preOrder"], "");
    const adminWardName = getNestedObject(
      deliveryDetails,
      ["adminWardName"],
      ""
    );
    const isPostalCode = getNestedObject(
      deliveryDetails,
      ["isPostalCode"],
      false
    );
    const lat = getNestedObject(deliveryDetails, ["lat"], "");
    const lon = getNestedObject(deliveryDetails, ["lon"], "");
    this.state = {
      listVisible: false,
      postalCode,
      title,
      flatNumber,
      routeName,
      preOrder,
      lat,
      lon,
      isPostalCode,
      adminWardName,
      addresses,
      focusedText: "",
      isOpen: false,
      placeInputValue: "",
      errorMessage: "",
      removeAll: false
    };
  }
  setLocalDataCallback = (newDeliveryDetails, route) => {
    const { delivery, preOrder, postalCode } = newDeliveryDetails;

    mixPanel.track("Change Delivery Details", {
      _postCode: postalCode,
      _when: preOrder || "Asap",
      _how: (delivery && "Delivery") || "Collection",
      _distance: 0
    });

    if (route === "list") {
      let href;
      if (newDeliveryDetails.adminWard) {
        href = `/restaurants/${newDeliveryDetails.city}/${
          newDeliveryDetails.adminWard
        }/?postcode=${
          newDeliveryDetails.postalCode
        }&time=${newDeliveryDetails.preOrder || "now"}`;
      } else {
        href = `/restaurants/${newDeliveryDetails.city}/list/?postcode=${
          newDeliveryDetails.postalCode
        }&time=${newDeliveryDetails.preOrder || "now"}`;
      }
      if (href) {
        window.location.href = href;
      }
    }
    if (route === "detail") {
      window.location.href = `/restaurant/${newDeliveryDetails.city}/${
        newDeliveryDetails.adminWard
      }/${newDeliveryDetails.slugName}/?postcode=${
        newDeliveryDetails.postalCode
      }&time=${newDeliveryDetails.preOrder || "now"}`;
    }
  };
  select = async (item, status) => {
    if (item) {
      const { preOrder } = this.state;
      const { route, slugName } = this.props;
      let newDeliveryDetails;
      if (status) {
        const {
          id,
          addressLine1,
          title,
          postalCode,
          slugAdminWard,
          city,
          adminWard
        } = item || null;
        newDeliveryDetails = {
          userAddressId: parseInt(id),
          routeName: addressLine1,
          title,
          postalCode,
          slugName,
          delivery: true,
          adminWard: slugAdminWard,
          adminWardName: adminWard,
          city: (city && city.slugName) || null,
          preOrder
        };
        if (city && city.slugName) {
          const jsonData = JSON.stringify(newDeliveryDetails);
          setLocalDeliveryData(jsonData, () =>
            this.setLocalDataCallback(newDeliveryDetails, route)
          );
        } else {
          window.location.href = "/unavaliable";
        }
      } else {
        const lat = item.lat,
          lon = item.lng,
          addresses = item.address,
          isPostalCode = item.isPostalCode;
        const {
          postalCode,
          routeName,
          addressLine2,
          flatNumber
        } = await getRegularPlaceData(addresses);
        const apiPostalCode = postalCode || "00000";
        Api.post(
          "/api/route/data",
          { postalCode: apiPostalCode },
          (postalResponse, postalErros) => {
            if (postalErros) {
              if (postalErros === 503) {
                this.setState(() => {
                  throw postalErros;
                });
              } else {
                console.log(postalErros, "postal code query error");
              }
            } else if (postalResponse.code) {
              var body = document.body;
              body.classList.add("body-overflow");
              const errorMessage = getAppErrors(postalResponse.code);
              this.setState({
                errorMessage:
                  (errorMessage && errorMessage.message) ||
                  postalResponse.message
              });
            } else {
              newDeliveryDetails = {
                lat,
                lon,
                postalCode,
                routeName,
                addressLine2,
                flatNumber,
                slugName,
                delivery: true,
                isPostalCode,
                adminWard:
                  (postalResponse.adminWard &&
                    postalResponse.adminWard.slugAdminWard) ||
                  "",
                adminWardName:
                  (postalResponse.adminWard &&
                    postalResponse.adminWard.adminWard) ||
                  "",
                city: postalResponse.city.slugName
              };
              const jsonData = JSON.stringify(newDeliveryDetails);
              setLocalDeliveryData(jsonData, () =>
                this.setLocalDataCallback(newDeliveryDetails, route)
              );
            }
          }
        );
      }
    }
  };
  getInputText = ({ lat, lon, flatNumber, routeName, postalCode }) => {
    let text = "";
    if (lat || lon) {
      if (routeName) {
        text = (flatNumber && `${flatNumber} ${routeName}`) || routeName;
      } else if (postalCode) {
        text = postalCode;
      }
    } else if (postalCode) {
      text = postalCode;
    }
    return text;
  };
  show = () => {
    const { lat, lon, flatNumber, routeName, postalCode } = this.state;
    let inputText = this.getInputText({
      lat,
      lon,
      flatNumber,
      routeName,
      postalCode
    });
    this.setState(
      { listVisible: true, isOpen: true, focusedText: inputText },
      () => {
        document.addEventListener("click", this.hide);
      }
    );
  };
  hide = event => {
    var el = document.getElementById("remove-all");
    var elA = document.getElementById("remove-all-a");
    var elInput = document.getElementById("place-input");
    var elCont = document.getElementById("dropdown-container");
    if (
      el === event.target ||
      elCont === event.target ||
      elA === event.target ||
      elInput === event.target ||
      event.target.className === "place-result"
    ) {
      return;
    } else {
      this.setState({
        listVisible: false,
        isOpen: false
      });
    }
    document.removeEventListener("click", this.hide);
  };
  renderListItems = () => {
    const { addresses } = this.state || [];
    return addresses.map((listItem, index) => {
      return (
        <div
          key={index}
          className="p-15"
          onClick={() => this.select(listItem, "address")}
        >
          <span>{listItem.title || listItem.addressLine1}</span>
        </div>
      );
    });
  };
  handleClickChange = () => {
    const { isOpen } = this.state;
    this.setState({
      isOpen: !isOpen
    });
  };
  handleChangeInput = placeInputValue => {
    this.setState(
      {
        placeInputValue,
        removeAll: false
      },
      () => {
        if (placeInputValue) {
          this.setState({ listVisible: false });
        } else {
          this.setState({ listVisible: true });
        }
      }
    );
  };
  handleRemoveInput = () => {
    this.setState({ removeAll: true, isOpen: false, listVisible: true }, () => {
      const placeInput = document.getElementById("place-input");
      if (placeInput) {
        placeInput.focus();
      }
      this.show();
    });
  };
  closeErrorMessage = () => {
    var body = document.body;
    body.classList.remove("body-overflow");
    this.setState({ errorMessage: null });
    this.setState({
      errorMessage: null
    });
  };
  render() {
    const {
      routeName,
      flatNumber,
      isOpen,
      listVisible,
      postalCode,
      addresses,
      removeAll,
      focusedText,
      errorMessage,
      isPostalCode,
      adminWardName
    } = this.state;
    return (
      <div
        className={
          "dropdown-container custom-dropdown-container" +
          (listVisible ? " show" : "")
        }
      >
        <div
          className={"dropdown-display" + (listVisible ? " clicked" : "")}
          onClick={this.show}
        >
          {(!isOpen && (
            <span id="dropdown-container">
              {getAddressText(
                routeName,
                flatNumber,
                postalCode,
                isPostalCode,
                adminWardName
              )}
            </span>
          )) || (
              <>
                <i className="icon icon-location-3" />
                <LocationSearchInput
                  onChange={this.handleChangeInput}
                  onSubmit={this.select}
                  removeAll={removeAll}
                  placeholder="e.g. 39 Old Town"
                  focusedText={focusedText}
                  divClass="initial"
                />

                <div
                  onClick={this.handleRemoveInput}
                  id="remove-all"
                  className="close-svg d-flex align-items-center justify-content-center"
                >
                  <a id="remove-all-a" className="icon icon-close" />
                </div>
              </>
            ) || (
              <>
                <i className="icon icon-location-3" />
                <LocationSearchInput
                  onChange={this.handleChangeInput}
                  onSubmit={this.select}
                  removeAll={removeAll}
                  placeholder="e.g. 39 Old Town"
                  focusedText={focusedText}
                  divClass="initial"
                />
              </>
            )}
          <i className="icon icon-arrow-left open" />
        </div>
        {errorMessage && (
          <AppErrors
            message={errorMessage}
            onClickClose={this.closeErrorMessage}
          />
        )}
        <div className="dropdown-list custom-dropdown-list">
          {(addresses && addresses.length && (
            <div>{this.renderListItems()}</div>
          )) || <noscript />}
        </div>
      </div>
    );
  }
}

const getAddressText = (
  routeName,
  flatNumber,
  postalCode,
  isPostalCode,
  adminWardName
) => {
  let text;
  if (postalCode || routeName) {
    if (isPostalCode || !routeName) {
      text = postalCode;
    } else {
      if (flatNumber) {
        text = `${flatNumber} ${routeName}`;
      } else {
        text = routeName;
      }
    }
  } else {
    text = adminWardName;
  }
  return text;
};
export default withRouter(DeliverTo);
